var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-549 -1540)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(549 1540)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M600.084,326.866a.763.763,0,0,0,.154.015.807.807,0,0,0,.791-.649.727.727,0,0,0,.014-.123,5.049,5.049,0,0,1,10.036,0,.8.8,0,0,0,.793.711h.094a.8.8,0,0,0,.7-.88,6.637,6.637,0,0,0-3.926-5.348,4.046,4.046,0,1,0-5.388,0,6.632,6.632,0,0,0-3.906,5.329.8.8,0,0,0,.635.945Zm5.964-11.741a2.45,2.45,0,1,1-2.45,2.45A2.453,2.453,0,0,1,606.049,315.126Z",
    transform: "translate(-47.054 1229.798)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDark);
export default __webpack_public_path__ + "static/media/user-dark.955cd8a1870a3f19e72d85fe6d21022e.svg";
export { ForwardRef as ReactComponent };